import { Component, Input, OnInit } from '@angular/core';
import { trackByRoute } from '../../utils/track-by';
import { NavigationService } from '../../services/navigation.service';
import { NavigationSubheading } from '../../interfaces/navigation-item.interface';
import icRadioButtonChecked from '@iconify/icons-ic/twotone-radio-button-checked';
import icRadioButtonUnchecked from '@iconify/icons-ic/twotone-radio-button-unchecked';
import { LayoutService } from '../../services/layout.service';
import { GlobalService } from 'src/@evo/services/global.service';
import { SharedService } from 'src/app/pages/Services/shared.service';
import { Router } from '@angular/router';

@Component({
  selector: 'nc-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  @Input() collapsed: boolean;
  collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;


  trackByRoute = trackByRoute;
  icRadioButtonChecked = icRadioButtonChecked;
  icRadioButtonUnchecked = icRadioButtonUnchecked;
  items: any;

  constructor(private navigationService: NavigationService,
    private layoutService: LayoutService,
    public globalService: GlobalService,
    private router: Router,
    private shareService: SharedService) { }

  ngOnInit() {

    //this.items = localStorage.getItem("mainMenu");
    this.items = this.navigationService.items.filter(item => !(item as NavigationSubheading).onlyVertical);
  }

  onMouseEnter() {
    this.layoutService.collapseOpenSidenav();
  }

  onMouseLeave() {
    this.layoutService.collapseCloseSidenav();
  }

  toggleCollapse() {
    this.collapsed ? this.layoutService.expandSidenav() : this.layoutService.collapseSidenav();
    this.globalService.setExpanded(this.collapsed);
  }
  gotoHome() {
    this.router.navigate(['/layout/dashboards/analytics']);
  }
}
